import { notificationEnums } from "@freetech/models/notifications";
import {
  Payment as PaymentIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Comment as CommentIcon,
  Receipt as ReceiptIcon,
  Notifications as NotificationsIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  CheckCircle as SuccessIcon,
  Error as ErrorIcon,
  CreditCard as CreditCardIcon,
  Dashboard as DashboardIcon,
  ViewKanban as ViewKanbanIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  Work as WorkIcon,
  Gavel as GavelIcon,
  AccessTime as TimeIcon,
  Update as UpdateIcon,
  Flag as FlagIcon,
  AlarmOn as AlarmIcon,
  Schedule as ScheduleIcon,
  AccountBalance as BankIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Done as DoneIcon,
  Close as CloseIcon,
  School as SchoolIcon,
} from "@mui/icons-material";

export const getNotificationIcon = (type: string) => {
  if (
    Object.values(notificationEnums.StakeholderNotificationType).includes(
      type as any
    )
  ) {
    switch (type) {
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_INVOICE_RECIEVED:
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_INVOICE_PAID:
        return ReceiptIcon;
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_PAYMENT_CREATED:
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_PAYMENT_COMPLETED:
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_PAYMENT_FAILED:
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_PAYMENT_REVERSED:
        return PaymentIcon;
      case notificationEnums.StakeholderNotificationType
        .STAKEHOLDER_CSA_RECIEVED:
        return DescriptionIcon;
    }
  }

  if (
    Object.values(notificationEnums.FreeloNotificationType).includes(
      type as any
    )
  ) {

    switch (type) {
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_CREATED:
        return ViewKanbanIcon;
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_UPDATED:
        return ViewKanbanIcon;
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_DELETED:
        return DeleteIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_CREATED:
        return ViewKanbanIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_UPDATED:
        return ViewKanbanIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_DELETED:
        return DeleteIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_ASSIGNED:
        return AssignmentIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_COMMENT_MENTION:
        return CommentIcon;
      case notificationEnums.FreeloNotificationType.FREELO_CARD_STATUS_CHANGED:
        return UpdateIcon;
      case notificationEnums.FreeloNotificationType.FREELO_DEADLINE_APPROACHING:
        return AlarmIcon;
      default:
        return ViewKanbanIcon;
    }
  }

  if (
    Object.values(notificationEnums.AdminNotificationType).includes(type as any)
  ) {
    switch (type) {
      case notificationEnums.AdminNotificationType.ADMIN_USER_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_USER_SIGNED_UP:
        return PersonIcon;
      case notificationEnums.AdminNotificationType
        .ADMIN_USER_ONBOARDING_COMPLETE:
        return SchoolIcon;
      case notificationEnums.AdminNotificationType.ADMIN_CLIENT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_CLIENT_UPDATED:
        return BusinessIcon;
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_UPDATED:
        return WorkIcon;
      case notificationEnums.AdminNotificationType.ADMIN_CSA_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_CSA_SIGNED_BY_ADMIN:
      case notificationEnums.AdminNotificationType
        .ADMIN_CSA_SIGNED_BY_STAKEHOLDER:
        return GavelIcon;
      case notificationEnums.AdminNotificationType.ADMIN_INVOICE_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_INVOICE_PAID:
        return ReceiptIcon;
      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_STATUS_CHANGED:
      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_COMPLETED:
        return PaymentIcon;
      case notificationEnums.AdminNotificationType
        .ADMIN_PROJECT_ASSIGNMENT_CREATED:
      case notificationEnums.AdminNotificationType
        .ADMIN_PROJECT_ASSIGNMENT_SIGNED:
        return AssignmentIcon;
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_SUBMITTED:
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_APPROVED:
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_REJECTED:
        return TimeIcon;
    }
  }

  if (
    Object.values(notificationEnums.FreelancerNotificationType).includes(
      type as any
    )
  ) {
    switch (type) {
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_PAYMENT_CREATED:
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_PAYMENT_UPDATED:
        return PaymentIcon;
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_PROJECT_ASSIGNMENT_CREATED:
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_PROJECT_ASSIGNMENT_COMPLETED:
        return AssignmentIcon;
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_AGREEMENT_CREATED:
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_AGREEMENT_REMINDER:
        return GavelIcon;
      case notificationEnums.FreelancerNotificationType
        .FREELANCER_ONBOARDING_COMPLETE:
        return SchoolIcon;
    }
  }

  return NotificationsIcon;
};
